
import Layout from "../../AllComponents/Layout"
import "./aboutUs.css";
import { useState , useEffect} from "react";
const imageLinkedIn = `${process.env.REACT_APP_IMAGEBASE_URL}/icon.svg`

const AboutUs = () => {

    const [gcmTeam, setGcmTeam] = useState([])
    const [gcmLead, setGcmLead] = useState([])


     useEffect(() => {


    fetch(`https://cms.nuego.in/api/our-teams?populate=*&sort=rank:asc`,
      {
        headers: {
          'Content-Type': 'application/json',
        },

      })
      .then((res) => res.json())

      .then(
        (res) => {
          if (res?.error) {
            setGcmTeam([])

          } else {
            setGcmTeam(res?.data)
          }

          return res;

        })

      .catch((err) => {
        return err;

      });

  }, [])

       useEffect(() => {


    fetch(`https://cms.nuego.in/api/our-leaders?populate=*&sort=rank:asc`,)
      .then((res) => res.json())
      .then(
        (res) => {
          if (res?.error) {
            setGcmLead([])

          } else {
            setGcmLead(res?.data)
          }
          return res;
        })
      .catch((err) => {
        return err;
      });
  }, [])
    return (
        <>
            <Layout>
                <section className='aboutbanner-sec'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h2 className='headingRout'> Home / <span> About Us </span> </h2>
                                <div className="aboutbannerpart">
                                    <h1>GreenCell Mobility is dedicated to building a platform for eMaaS (Electric Mobility-as-a-Service)</h1>
                                    <figure className="mb-0">
                                        {/* <img src={aboutbannerimg} alt="img" />  */}
                                        <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/aboutbannerimg.png`} alt="img" />

                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="mt-5">
                    <div className="container">
                        <div className="row">
                            <div className='col-12'>
                                <div className='aboutpart'>
                                    <div className='leftpart'>
                                        <h2>GreenCell wants to be the prime mover in building a sustainable growth momentum in the shared e-mobility space </h2>
                                    </div>
                                    <div className='rightpart'>
                                        <p> GreenCell has been promoted by EverSource Capital, the fund manager of India’s pioneering climate impact fund. EverSource Capital is an equal joint venture between Everstone Group, one of Asia’s premier investment groups with assets in excess of US$6 billion across private equity, real estate, credit, climate impact investments and green infrastructure and venture capital; and Lightsource bp, a global leader in development and management of solar energy projects. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
              <section className="aboutteam-slider videoLink">
                    <div className="container">
                        <div className="row">
                            <div className='col-12'>
                                <iframe
                                    src="https://www.youtube.com/embed/OKBRKHlYbVs?si=PrYXmtzZHeB-Eeqa&autoplay=1&mute=1" className="w-100">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='aboutteamsection'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className="aboutteam_box">
                                    <div className=" aboutteam_text">
                                        <h2> Our Team </h2>
                                        <p>Some truly talented and purpose-led folks have jumped aboard GreenCell. Each one of them comes with expertise in their domain - modest and jovial yet resolute and hungry to make things happen.</p>
                                        <button className="btn active" >Board of Directors </button>
                                    </div>
                                    <ul className="teamlist">
                                        {gcmLead?.map((el, id) => {
                                            return (
                                                <li key={id}>
                                                    <figure>
                                                        <img src={el?.attributes?.profilePic} alt="img" className={`teammemberimg coverImag`} />
                                                       { el?.attributes?.linkedin && <span>
                                                            <a href={el?.attributes?.linkedin} target="_blank">    <img src={imageLinkedIn}  alt="img" className="" /></a>
                                                        </span>}
                                                    </figure>
                                                    <h3>{el?.attributes?.name}</h3>
                                                    <h4>{el?.attributes?.designation}</h4>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                    <div className=" aboutteam_text">
                                        <button className="btn active" >GreenCell Leadership </button>
                                    </div>
                                    <ul className="teamlist">
                                        {gcmTeam?.map((el, id) => {
                                            return (
                                                <li key={id}>
                                                    <figure>
                                                        <img src={el?.attributes?.image} alt="img" className={`teammemberimg coverImag`} />
                                                        {el?.attributes?.linkedin && <span>
                                                            <a href={el?.attributes?.linkedin} target="_blank">
                                                                <img src={imageLinkedIn} alt="img" className="" />
                                                            </a>
                                                        </span>}
                                                    </figure>
                                                    <h3>{el?.attributes?.name}</h3>
                                                    <h4>{el?.attributes?.designation}</h4>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>

        </>
    )
}

export default AboutUs